export interface ApiNote {
  id: string;
  firmId: string;
  title: string;
  content: string;
  tags: unknown;
  linkedTo: string | null;
  linkedType: string | null;
  isPinned: boolean;
  authorId: string;
  createdAt: string;
  updatedAt: string;
  author: { id: string; name: string; email: string; avatar: string | null } | null;
}

export type NoteLink = 'client' | 'task' | 'none';

export interface NoteView {
  id: string;
  title: string;
  content: string;
  tags: string[];
  linkedTo: NoteLink;
  linkedId: string | null;
  linkedName: string;
  createdBy: string;
  createdAt: string;
  isPinned: boolean;
}

const LINK_LABELS: Record<Exclude<NoteLink, 'none'>, string> = {
  client: 'Linked client',
  task: 'Linked task',
};

function toLink(linkedType: string | null, linkedTo: string | null): NoteLink {
  if (!linkedTo) return 'none';
  return linkedType === 'client' || linkedType === 'task' ? linkedType : 'none';
}

export function toNoteView(note: ApiNote): NoteView {
  const link = toLink(note.linkedType, note.linkedTo);
  return {
    id: note.id,
    title: note.title,
    content: note.content,
    tags: Array.isArray(note.tags) ? note.tags.filter((t): t is string => typeof t === 'string') : [],
    linkedTo: link,
    linkedId: link === 'none' ? null : note.linkedTo,
    linkedName: link === 'none' ? '' : LINK_LABELS[link],
    createdBy: note.author?.name ?? 'Unknown',
    createdAt: note.createdAt,
    isPinned: note.isPinned,
  };
}
